// type error/warning/failed
// popover message
import { Component, Input } from '@angular/core';

@Component({
    selector: 'syn-validation-icon-tooltip',
    templateUrl: './validation-icon-tooltip.component.html',
})
export class ValidationIconTooltipComponent {
    @Input() type: 'ERROR' | 'SUCCESS' | 'PENDING';
    @Input() message: string;

}
